import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getMerchantData, Signin } from '../../../components/actions/auth';
 // <-- IMPORTANT
import Loader from '../../../components/utils/Loader';

export default function Login() {
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // ---------- AUTO LOGIN USING QUERY PARAM ----------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");

    if (!encoded) {
      setLoading(false);
      return;
    }

    try {
      const decoded = JSON.parse(atob(encoded));
      setLoading(true);

      Signin(decoded).then(async (res) => {
        if (res.message === "success") {
          const user = res.data[0];

          // Common session storage
          sessionStorage.setItem("userData", JSON.stringify(user));
          sessionStorage.setItem("industry", user?.industry);
          sessionStorage.setItem("clientId", user?.merchantClientId);
          sessionStorage.setItem("name", user?.name);
          sessionStorage.setItem("email", user?.email);
          sessionStorage.setItem("isAdmin", user?.isAdmin ? "true" : "false");

          // Admin
          if (user.isAdmin) {
            const r2 = await getMerchantData("MER35806788");
            sessionStorage.setItem("code", r2?.data?.merchants[0]?.Code);
            setLoading(false);
            navigate("/dashboard");
          }

          // Normal merchant
          else {
            sessionStorage.setItem("code", user?.code);
            setLoading(false);
            navigate("/dashboard");
          }

        } else {
          setLoading(false);
          alert("Merchant login failed");
        }
      });

    } catch (err) {
      console.log("Decode error:", err);
      setLoading(false);
    }
  }, []);


  // ---------- NORMAL LOGIN ----------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await Signin({ email, password });

      if (res?.message === "success") {
        const user = res?.data[0];

        // Common session storage
        sessionStorage.setItem("userData", JSON.stringify(user));
        sessionStorage.setItem("industry", user?.industry);
        sessionStorage.setItem("clientId", user?.merchantClientId);
        sessionStorage.setItem("name", user?.name);
        sessionStorage.setItem("email", user?.email);
        sessionStorage.setItem("isAdmin", user?.isAdmin ? "true" : "false");

        // Admin Logic
        if (user.isAdmin) {
          const r2 = await getMerchantData("MER35806788");
          sessionStorage.setItem("code", r2?.data?.merchants[0]?.Code);
          setLoading(false);
          navigate("/dashboard");
        }

        // Normal merchant
        else {
          sessionStorage.setItem("code", user?.code);
          setLoading(false);
          navigate("/dashboard");
        }
      }

      else {
        setLoading(false);
        setError(res?.message || "Invalid email or password");
      }

    } catch (err) {
      console.log(err);
      setError("Something went wrong. Please try again later.");
      setLoading(false);
    }
  };


return ( <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4"> {/* FULL PAGE LOADER */} {loading && <Loader />} <div className="max-w-md w-full"> {/* Logo Section */} <div className="text-center mb-8"> <div className="inline-flex items-center gap-3 mb-4"> <img src="/primexlogo.png" alt="PrimeX Loyalty" className="w-25 h-16" /> </div> <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1> <p className="text-gray-600">Sign in to your merchant account</p> </div> {/* Login Card */} <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8"> <form onSubmit={handleSubmit} className="space-y-6"> {error && ( <div className="bg-red-50 border border-red-200 rounded-lg p-4"> <div className="flex items-center gap-3"> <i className="ri-error-warning-line text-red-500"></i> <p className="text-red-700 text-sm">{error}</p> </div> </div> )} <div> <label className="block text-sm font-semibold text-gray-700 mb-2"> Email Address </label> <div className="relative"> <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i> <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg" placeholder="Enter your email" required /> </div> </div> <div> <label className="block text-sm font-semibold text-gray-700 mb-2"> Password </label> <div className="relative"> <i className="ri-lock-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i> <input type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg" placeholder="Enter your password" required /> <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" > <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i> </button> </div> </div> <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-lg font-semibold" > Sign In </button> <div className="mt-6 text-center"> <p className="text-gray-600"> Don't have an account?{' '} <Link to="/signup" className="text-blue-600 hover:text-blue-800 font-medium transition duration-200"> Sign Up </Link> </p> </div> </form> </div> </div> </div> );
}
